export const NINJA_EVENTS = {
  FETCHING_MATRIX: 'fetching_matrix',
};
